// extracted by mini-css-extract-plugin
export default {"light":"styles_light__vprfd","disconnectModal":"styles_disconnectModal__AKq79","disconnectBtn":"styles_disconnectBtn__4QJOI"};